import { render, staticRenderFns } from "./TkIcon.vue?vue&type=template&id=245a71e6&scoped=true&"
import script from "./TkIcon.vue?vue&type=script&lang=js&"
export * from "./TkIcon.vue?vue&type=script&lang=js&"
import style0 from "./TkIcon.vue?vue&type=style&index=0&id=245a71e6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245a71e6",
  null
  
)

export default component.exports